(() => {
  if (window.GmlColorScheme) return;
  const root = document.documentElement;
  const storageKey = 'gml_color_scheme_v1';
  const normalize = value => value === 'dark' ? 'dark' : 'light';
  const syncSwitches = () => {
    document.querySelectorAll('[data-gml-night-toggle]').forEach(button => {
      button.setAttribute('aria-checked', String(root.dataset.gmlColorScheme === 'dark'));
      button.hidden = false;
    });
  };
  const apply = (value, persist = false) => {
    const scheme = normalize(value);
    root.dataset.gmlColorScheme = scheme;
    root.style.colorScheme = scheme;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = scheme === 'dark' ? '#17191b' : '#ffffff';
    if (persist) {
      try { localStorage.setItem(storageKey, scheme); } catch (_) {
        try { sessionStorage.setItem(storageKey, scheme); } catch (_) {}
      }
    }
    syncSwitches();
    window.dispatchEvent(new CustomEvent('gml:color-scheme', {detail: {scheme}}));
  };
  const restore = () => {
    let scheme = root.dataset.gmlColorScheme;
    try { scheme = localStorage.getItem(storageKey) || scheme; } catch (_) {
      try { scheme = sessionStorage.getItem(storageKey) || scheme; } catch (_) {}
    }
    apply(scheme);
  };
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-gml-night-toggle]') : null;
    if (!button) return;
    apply(root.dataset.gmlColorScheme === 'dark' ? 'light' : 'dark', true);
  });
  window.addEventListener('storage', event => {
    if (event.key === storageKey || event.key === null) apply(event.newValue);
  });
  window.addEventListener('pageshow', restore);
  document.addEventListener('shopify:section:load', syncSwitches);
  window.GmlColorScheme = {set: scheme => apply(scheme, true)};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, {once: true});
  else restore();
})();
